import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { VendorLoginService } from '../shared/services/vendor-login.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-vendorresetpasword',
  templateUrl: './vendorresetpasword.component.html',
  styleUrls: ['./vendorresetpasword.component.scss']
})
export class VendorresetpaswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  isSubmitting = false;
  showNewPassword = false;
  showConfirmPassword = false;
  mailId: string = '';

  constructor(
    private fb: FormBuilder,
    private vendorLoginService: VendorLoginService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {
    this.resetPasswordForm = this.fb.group({
      vendorPassword: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.mailId = params['mailId'] || '';
    });
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  passwordMatchValidator(group: AbstractControl) {
    const password = group.get('vendorPassword')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return password === confirm ? null : { passwordMismatch: true };
  }

  onSubmit(): void {
    if (this.resetPasswordForm.invalid || !this.mailId) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const { vendorPassword, confirmPassword } = this.resetPasswordForm.value;

    const payload = {
      mailId: this.mailId,
      vendorPassword: vendorPassword,
      confirmPassword: confirmPassword 
    };

    this.vendorLoginService.vendorresetpassoword(payload).subscribe({
      next: (res) => {
        this.isSubmitting = false;
        if (res) {
          this.toastr.success('Password reset successfully!');
          this.router.navigate(['/vendor-login']);
        } else {
          this.toastr.error(res.body?.message || 'Password reset failed.');
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        this.toastr.error(err.error?.message || 'Something went wrong.');
      }
    });
  }
}
